import { useTranslation } from "react-i18next";
import styled from "styled-components";
import media from "../../styles/media";
import Container from "../ui/Container";
import { ButtonLink } from "../ui/Button";
import { ROUTES } from "../../config/routes";
import collage from "../../assets/img/about-collage.png";
import emblem from "../../assets/img/emblem.png";

const Wrapper = styled.section`
  padding: 72px 0;

  ${media.md} {
    padding: 40px 0;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: center;

  ${media.lg} {
    grid-template-columns: 1fr;
    gap: 32px;
  }
`;

const Illustration = styled.img`
  width: 100%;
  height: auto;
  border-radius: ${({ theme }) => theme.radii.md};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
`;

const Emblem = styled.img`
  width: 64px;
  height: auto;
`;

const Title = styled.h2`
  font-size: ${({ theme }) => theme.fontSizes.h3};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
`;

const Description = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.md};
`;

export function AboutSection() {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Container>
        <Grid>
          <Illustration src={collage} alt="" loading="lazy" />

          <Content>
            <Emblem src={emblem} alt="" />
            <Title>{t("branchTitle")}</Title>
            <Description>{t("branchDescription")}</Description>
            <ButtonLink to={ROUTES.organization}>{t("readMore")}</ButtonLink>
          </Content>
        </Grid>
      </Container>
    </Wrapper>
  );
}

export default AboutSection;
